var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-tooltip" },
    [
      _c(
        "button",
        {
          class: ["c-tooltip__button", { active: _vm.isActive }],
          attrs: {
            type: "button",
            "aria-expanded": _vm.isActive.toString(),
            "aria-label": "Tooltip"
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.toggleTooltip($event)
            }
          }
        },
        [
          _c(
            "svg",
            {
              staticClass: "c-tooltip__svg",
              attrs: { "aria-hidden": "true", focusable: "false" }
            },
            [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#info-rap"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "tooltip" } }, [
        _vm.isActive
          ? _c("div", { staticClass: "c-tooltip__container" }, [
              _c("div", { staticClass: "c-tooltip__inner" }, [
                _vm.title
                  ? _c("h2", { staticClass: "c-tooltip__title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "c-tooltip__close",
                    attrs: { "aria-label": "Close tooltip button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toggleTooltip($event)
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "c-tooltip__svg c-tooltip__svg--close",
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#cross-rap"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-tooltip__summary" },
                [
                  _vm._t("default"),
                  _vm._v(" "),
                  _vm.image
                    ? _c("img", { staticClass: "c-tooltip__image" })
                    : _vm._e()
                ],
                2
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0278ad40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0278ad40","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/_contact-us-rap/_vue/ToolTip.vue
// module id = 668
// module chunks = 0